import { Button } from '@mui/material';
import * as React from 'react';

import { useCurrentEventQuery } from '../../event/hooks/useCurrentEventQuery';
import { useCurrentUserQuery } from '../../user/hooks/useCurrentUserQuery';
import { HeroLayout } from './HeroLayout';
import Typography from './HomeTypography';

export const Hero = () => {
  const { data: currentUserData } = useCurrentUserQuery(true);
  const { data: currentEventData, loading } = useCurrentEventQuery();
  const currentEvent = currentEventData?.currentEvent ?? null;

  return (
    <HeroLayout
      sxBackground={{
        backgroundImage: `url(/home/hero.jpg)`,
        backgroundColor: '#7fc7d9', // Average color of the background image.
        backgroundPosition: 'center',
      }}
    >
      {/* Increase the network loading priority of the background image. */}
      <img
        style={{ display: 'none' }}
        src={'/home/hero.jpg'}
        alt="increase priority"
      />
      <Typography variant="h2" align="center" fontWeight="medium">
        {loading
          ? ''
          : (currentEvent?.name ??
            'Ce site gère les événements de la flute comme le WET et le pré WET')}
      </Typography>
      <Typography
        color="inherit"
        align="center"
        variant="h5"
        sx={{ mb: 4, mt: { xs: 4, sm: 10 } }}
      >
        {currentEvent?.description ?? "Il n'y a pas d'événement pour le moment"}
      </Typography>
      {currentUserData ? (
        <Button
          color="primary"
          variant="contained"
          size="large"
          component="a"
          href="/dashboard"
          sx={{ minWidth: 200 }}
        >
          Mon espace
        </Button>
      ) : (
        <Button
          color="primary"
          variant="contained"
          size="large"
          component="a"
          href="/create-account"
          sx={{ minWidth: 200 }}
        >
          Créer votre compte
        </Button>
      )}
    </HeroLayout>
  );
};
